import React, { useRef, useState, useEffect, useMemo } from "react";
import { matchesAccountSearch, matchesAccountFilters } from "../../utils/accountSearch";
import "react-calendar/dist/Calendar.css";
import "../../assets/css/common.css";
import "../../assets/css/Profile.css";
import "../../assets/css/tooltip.css";
import { getAllUserAccountDetails, getUserAccountApproved, getUserAccountbanned, getUserAccountUnbanned } from "../../API/userApi"
import { useNavigate } from 'react-router-dom';
import { Button, Table } from "reactstrap";
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { FaEdit } from "react-icons/fa";
import UpdateUser from "./updateUser";
import { useLoggedInUser } from "../../config/zStore";
import FilterComponent from "../../components/filter";
import SearchComponent from "../../components/search";

function UserTable() {

  const [accountDetails, setAccountDetails] = useState(null)
  const [filters, setFilters] = useState([])
  const [modal, setModal] = useState(false)
  const [userDetails, setUserDetails] = useState(null)
  const [searchTerm, setSearchTerm] = useState('');

  const navigate = useNavigate();
  const { userData: signedInUser } = useLoggedInUser();

  const getUsertAccountDetailsHandler = async () => {
    const users = await getAllUserAccountDetails()
    setAccountDetails(users)
  }

  useEffect(() => {
    if(!modal){
      getUsertAccountDetailsHandler()
    }
  },[modal])
 
  const approveAccountHandler = async (users) => {
    const res = await getUserAccountApproved(users)
    if(res?.status == 200){
      toast.success(res.data.message);
      getUsertAccountDetailsHandler()
      return
    }
    toast.error(res?.data?.message || "Something went wrong");
  }

  const banAccountHandler = async (users) => {
    const res = await getUserAccountbanned(users)
    if(res?.status == 200){
      toast.success(res.data.message);
      getUsertAccountDetailsHandler()
      return
    }
    toast.error(res?.data?.message || "Something went wrong");
  }

  const getUserAccountUnbannedHandler = async (users) => {
    const res = await getUserAccountUnbanned(users)
    if(res.status == 200){
      toast.success(res.data.message);
      getUsertAccountDetailsHandler()
      return
    }
    toast.error("Something went wrong");
  }

  // Search and filters are kept separately and applied together. Each used to
  // rebuild the list from scratch, so using one discarded the other - and both
  // were lost whenever an account was approved or banned and the list reloaded
  // (QA finding ADMIN-04).
  const accountDetailsToShow = useMemo(
    () =>
      (accountDetails || []).filter(
        (user) => matchesAccountFilters(user, filters) && matchesAccountSearch(user, searchTerm)
      ),
    [accountDetails, filters, searchTerm]
  );

  const filterHandler = (selected) => setFilters(selected || []);

  const handleSearchChange = (e) => setSearchTerm(e.target.value);

  return (
    <>
      {modal && <UpdateUser modal={modal} setModal={setModal} userDetails={userDetails}/>}
      <div className="d-flex align-items-top justify-content-end">
        <SearchComponent handleSearchChange={handleSearchChange} searchTerm= {searchTerm}/>
        <FilterComponent filterHandler={filterHandler}/>
      </div>
      <div style={{ maxHeight: "60vh", overflow: "auto" }}>
        <Table
          hover
          striped
          responsive
          style={{ marginTop: '15px'}}
        >
          <thead>
            <tr >
              <th style={{ fontSize:"smaller", textAlign: "center" }}>Name</th>
              <th style={{ fontSize:"smaller", textAlign: "center" }}>Email </th>
              <th style={{ fontSize:"smaller", textAlign: "center" }}>Role</th>
              <th style={{ fontSize:"smaller", textAlign: "center" }}>Sub Role</th>
              <th style={{ fontSize:"smaller", textAlign: "center" }}>Phone #</th>
              <th style={{ fontSize:"smaller", textAlign: "center" }}>Action</th>
            </tr>
          </thead>
          <tbody className="alignCenter">
            { accountDetailsToShow && accountDetailsToShow.map((user) => {
              return <tr key={user._id}>
                <td
                  className="primary2 tablePlaceContent"
                > 
                  {user.fullname}
                </td>
                <td
                  className="primary2 tablePlaceContent"
                > 
                  {user.email}
                </td>
                <td
                  className="primary2 tablePlaceContent"
                > 
                  {user.rollSelect}
                </td>
                <td
                  className="primary2 tablePlaceContent"
                > 
                  {user.subRole.length > 0 ? 
                    user.subRole.map(role => (
                      <div key={role}>
                        {role}
                      </div>
                    ))
                  : "Not Selected"
                  }
                </td>
                <td
                  className="primary2 tablePlaceContent"
                > 
                  {user.phoneNo}
                </td>
                <td
                  className="primary2 tablePlaceContent"
                > 
                  {/* <FaEdit className="fs-5 cursor-pointer"
                    /> */}
                  {user.accountRequest && user.emailVerified === false ?
                    // Approval waits until they open the link we emailed them.
                    <span className="text-muted" title="They have not opened the confirmation link we emailed them.">
                      Email not confirmed
                    </span>
                  : user.accountRequest ?
                    <Button
                      type='submit' className="Update_btn"
                      onClick={() => approveAccountHandler(user)}
                    >
                      Approve Account
                    </Button>
                  :  user.banAccount ?
                    <Button
                      type='submit' className="Update_btn"
                      onClick={() => getUserAccountUnbannedHandler(user)}
                    >
                      Un Ban Account
                    </Button>
                  :
                    <div className="flex items-center">
                      {/* No ban button on your own row: it would lock you out. */}
                      {String(user._id) !== String(signedInUser?._id) && (
                        <Button
                          type='button' color="danger"
                          onClick={() => banAccountHandler(user)}
                        >
                          Ban Account
                        </Button>
                      )}
                      <FaEdit className="fs-5 cursor-pointer mx-3"
                        onClick={() => {
                          setUserDetails(user)
                          setModal(true)
                        }}
                      />
                    </div>
                  }
                </td>
              </tr>
            })
            }
            
          </tbody>
        </Table>
      </div>
    </>
  );
}

export default UserTable;
